import styled from 'styled-components'
import { Text, themeColor, themeFontFamily } from 'LibNeo'
import { ORIENTATION } from 'Constants/Global'

export const TextRow = styled.div<{ orientation: ORIENTATION }>`
	display: flex;
	flex-direction: ${({ orientation }) =>
		orientation === ORIENTATION.HORIZONTAL ? 'row' : 'column'};
	color: ${themeColor('gray', 6)};
	font-family: ${themeFontFamily('SBSansText')};
	font-size: 14px;
	line-height: 20px;
	width: 100%;
	word-break: break-word;
	gap: ${({ orientation }) => `${orientation === ORIENTATION.HORIZONTAL ? 40 : 0}px`};
	margin-bottom: ${({ orientation }) => `${orientation === ORIENTATION.HORIZONTAL ? 12 : 16}px`};
	align-items: flex-start;
`

export const Title = styled.div<{ orientation: ORIENTATION }>`
	display: flex;
	flex-direction: row;
	font-size: ${({ orientation }) => `${orientation === ORIENTATION.HORIZONTAL ? 14 : 12}px`};
	min-width: 160px;
	width: 160px;
	align-items: center;
`

export const Value = styled(Text)`
	display: flex;
`

export const Space = styled.div`
	height: 16px;
`
